import { useEffect, useState, RefObject } from 'react';

export const useIsScrolling = (scrollContainerRef?: RefObject<HTMLDivElement>) => {
  const [isScroll, setIsScroll] = useState<boolean>(false);
  let resetTimeout;

  const resetIsScroll = () => {
    setIsScroll(false);
    resetTimeout = setTimeout(resetIsScroll, 300);
  };

  useEffect(() => {
    const scrollingContainer = scrollContainerRef?.current ? scrollContainerRef.current : window;

    const setIsScrollTrue = () => {
      setIsScroll(true);
    };

    scrollingContainer.addEventListener('scroll', setIsScrollTrue);
    resetIsScroll();
    
    return () => {
      scrollingContainer.removeEventListener('scroll', setIsScrollTrue);
      clearTimeout(resetTimeout);
    };
  }, []);

  return isScroll;
};